module.exports = __webpack_public_path__ + "img/digital-park.d41b9ff9.svg";